export const WIDGET_TYPE = {
  text: 'text',
  barcode: 'barcode',
  row: 'row',
  footer: 'footer',
  pageNumber: 'page-number',
  pagesCount: 'pages-count',
  line: 'line',
} as const;
